export default __webpack_public_path__ + "static/media/circ3dslice.dc2626c1.jpg";